<div class="registaration">
  <div class="r-header">
    <img src="assets/images/logo-dark.svg" alt="">
  </div>
  <div class="sidebar">
    <img src="assets/images/logo2.svg" class="logo" alt="">
    <h2>
      Start your remarkable journey with us!
    </h2>
    <img src="assets/images/r-sidebar-v.svg" class="r-sidebar-v animated" alt="">
  </div>
  <div class="form-body">

    <div class="cant-have-account">
      <a (click)="goBack()" class="back-to-home">
        <i class="fa-solid fa-arrow-left"></i>
        <span>Go to Home</span>
      </a>
      <div class="account">
        <span>
          Don’t have an account?
        </span>
        <a [routerLink]="'/auth/signup'">
          Sign up
        </a>
      </div>
    </div>

    <form (ngSubmit)="verifyOtp()">
      <div class="form-card">
        <h3 class="title">
          Insert OTP
        </h3>

        <div class="otp-inputs">
          <input type="text" class="form-control" maxlength="1" [(ngModel)]="firstChar" name="firstChar"
            (input)="onInput($event, null, firstCharInput, secondCharInput)"
            (keydown)="onKeyDown($event, null, firstCharInput)" (paste)="onPaste($event)" #firstCharInput
            placeholder="0">
          <input type="text" class="form-control" maxlength="1" [(ngModel)]="secondChar" name="secondChar"
            (input)="onInput($event, firstCharInput, secondCharInput, thirdCharInput)"
            (keydown)="onKeyDown($event, firstCharInput, secondCharInput)" (paste)="onPaste($event)" #secondCharInput
            placeholder="0">
          <input type="text" class="form-control" maxlength="1" [(ngModel)]="thirdChar" name="thirdChar"
            (input)="onInput($event, secondCharInput, thirdCharInput, fourthCharInput)"
            (keydown)="onKeyDown($event, secondCharInput, thirdCharInput)" (paste)="onPaste($event)" #thirdCharInput
            placeholder="0">

          <input type="text" class="form-control" maxlength="1" [(ngModel)]="fourthChar" name="fourthChar"
            (input)="onInput($event, thirdCharInput, fourthCharInput)"
            (keydown)="onKeyDown($event, thirdCharInput, fourthCharInput)" (paste)="onPaste($event)" #fourthCharInput
            placeholder="0">
        </div>
        <button class="btn btn-primary btn-md w-100" [ngClass]="resendOpt ? 'btn-gray' : 'btn-primary'" type="button"
          (click)="resendOpt ? resendOtp() : verifyOtp()">
          {{ resendOpt ? 'Send code again' : 'Verify' }}
        </button>
        <p *ngIf="!resendOpt">Wait {{ optExpiray }} seconds before requesting a new code</p>
      </div>
    </form>
    <div></div>
  </div>
</div>

<!-- <div class="container-fluid login-container">
  <div class="row">
    <div class="col-lg-6 h-100 d-none d-lg-block">
      <div class="login-container_content">
        <span class="logo-box">
          <img src="../../../../assets/images/Luqta-03.svg" alt="logo" class="img-fluid logo-img" />
        </span>
        <div class="login-content">
          <h2 class="login-title">Start your remarkable journey with us!</h2>
          <p class="login-text">
            Our cold email automation helps you send personalized cold
            <br />
            emails at scale with high email deliverability.
          </p>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="login-container_form">
        <h2 class="login-title">Please check your Inbox</h2>
        <p class="login-text">
          We have send code to
        </p>
        <p class="login-text">
          "{{codeSendChannel}}"
        </p>
        <form class="login-form" style="margin-top: 0px;" (ngSubmit)="verifyOtp()">
          <div class="form-group otp-card mb-4-5">
            <label for="phone">Enter OTP</label>
            <div class="d-flex justify-content-between opt-input">
              <input type="text" class="form-control" maxlength="1" [(ngModel)]="firstChar" name="firstChar"
                (input)="onInput($event, null, firstCharInput, secondCharInput)"
                (keydown)="onKeyDown($event, null, firstCharInput)" (paste)="onPaste($event)" #firstCharInput
                placeholder="0">

              <input type="text" class="form-control" maxlength="1" [(ngModel)]="secondChar" name="secondChar"
                (input)="onInput($event, firstCharInput, secondCharInput, thirdCharInput)"
                (keydown)="onKeyDown($event, firstCharInput, secondCharInput)" (paste)="onPaste($event)"
                #secondCharInput placeholder="0">

              <input type="text" class="form-control" maxlength="1" [(ngModel)]="thirdChar" name="thirdChar"
                (input)="onInput($event, secondCharInput, thirdCharInput, fourthCharInput)"
                (keydown)="onKeyDown($event, secondCharInput, thirdCharInput)" (paste)="onPaste($event)" #thirdCharInput
                placeholder="0">

              <input type="text" class="form-control" maxlength="1" [(ngModel)]="fourthChar" name="fourthChar"
                (input)="onInput($event, thirdCharInput, fourthCharInput)"
                (keydown)="onKeyDown($event, thirdCharInput, fourthCharInput)" (paste)="onPaste($event)"
                #fourthCharInput placeholder="0">
            </div>
          </div>

          <div class="form-group">
            <button class="btn btn-primary w-100" [disabled]="resendOpt" type="submit">Verify</button>
          </div>

          <div class="form-group text-center mt-2">
            <span class="btn btn-gray w-100 mt-4" *ngIf="resendOpt" (click)="resendOtp()">Send code
              again</span>
            <p class="opt-time text-center mt-4" *ngIf="!resendOpt">{{ optExpiray }}</p>
          </div>

        </form>
      </div>
    </div>
  </div>
</div> -->
<nz-modal [(nzVisible)]="enterprizeModal" nzTitle="Contact us For Enterprise Plan"
  (nzOnCancel)="handleEnterprizeCancel()" (nzOnOk)="handleEnterprizeOk()" [nzOkDisabled]="enterprizeForm.invalid"
  [nzCentered]="true" nzOkText="Submit" [nzWidth]="700">
  <ng-container *nzModalContent>
    <form [formGroup]="enterprizeForm" class="enterprise-form-grid">
      <input type="hidden" formControlName="plan_id" />

      <div class="form-grid">
        <!-- Name -->
        <div class="form-group">
          <label>Your Name</label>
          <input class="form-control border-0" nz-input type="text" formControlName="name"
            placeholder="Enter your name" />
          <div class="error text-danger pt-2" *ngIf="
              enterprizeForm.get('name')?.touched &&
              enterprizeForm.get('name')?.invalid
            ">
            <span *ngIf="enterprizeForm.get('name')?.hasError('required')">
              This field is required
            </span>
            <span *ngIf="enterprizeForm.get('name')?.hasError('minlength')">
              Name must be at least 3 characters
            </span>
            <span *ngIf="enterprizeForm.get('name')?.hasError('pattern')">
              Only alphabets are allowed
            </span>
          </div>
        </div>

        <!-- Company Name -->
        <div class="form-group">
          <label>Company Name</label>
          <input nz-input type="text" formControlName="company_name" placeholder="Enter your company name" />
          <div class="error text-danger pt-2" *ngIf="
              enterprizeForm.get('company_name')?.touched &&
              enterprizeForm.get('company_name')?.invalid
            ">
            This field is required
          </div>
        </div>

        <!-- Email -->
        <div class="form-group">
          <label>Email</label>
          <input nz-input type="email" formControlName="email" placeholder="Enter email" />
          <div class="error text-danger pt-2" *ngIf="
              enterprizeForm.get('email')?.touched &&
              enterprizeForm.get('email')?.invalid
            ">
            <span *ngIf="enterprizeForm.get('email')?.hasError('required')">
              This field is required
            </span>
            <span *ngIf="enterprizeForm.get('email')?.hasError('email')">
              Enter a valid email address
            </span>
            <span *ngIf="enterprizeForm.get('email')?.hasError('pattern')">
              {{ "Only Gmail addresses are allowed (must end with @.com)" }}
            </span>
          </div>
        </div>

        <!-- Phone Number -->
        <div class="form-group">
          <label>Phone Number</label>
          <input nz-input type="number" formControlName="phone_number" placeholder="Enter phone number" />
          <div class="error text-danger pt-2" *ngIf="
              enterprizeForm.get('phone_number')?.touched &&
              enterprizeForm.get('phone_number')?.invalid
            ">
            <span *ngIf="enterprizeForm.get('phone_number')?.hasError('required')">
              This field is required
            </span>
            <span *ngIf="enterprizeForm.get('phone_number')?.hasError('pattern')">
              Phone number must be digits only (10-15 numbers)
            </span>
          </div>
        </div>

        <!-- Address -->
        <div class="form-group">
          <label>Address</label>
          <input nz-input type="text" formControlName="address" placeholder="Enter your address" />
          <div class="error text-danger pt-2" *ngIf="
              enterprizeForm.get('address')?.touched &&
              enterprizeForm.get('address')?.invalid
            ">
            This field is required
          </div>
        </div>

        <!-- Payment Method -->
        <div class="form-group">
          <label>Preferred Payment Method</label>
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select Payment Method" class="custom-select white-select"
            formControlName="payment_method">
            <nz-option nzValue="cash" nzLabel="Cash"></nz-option>
            <nz-option nzValue="online" nzLabel="Online"></nz-option>
          </nz-select>
          <div class="error text-danger pt-2" *ngIf="
              enterprizeForm.get('payment_method')?.touched &&
              enterprizeForm.get('payment_method')?.invalid
            ">
            This field is required
          </div>
        </div>

        <!-- Details -->
        <div class="form-group full-width">
          <label>Details</label>
          <textarea nz-input rows="3" formControlName="details" placeholder="Your Details here..."></textarea>
          <div class="error text-danger pt-2" *ngIf="
              enterprizeForm.get('details')?.touched &&
              enterprizeForm.get('details')?.invalid
            ">
            This field is required
          </div>
        </div>
      </div>
    </form>
  </ng-container>
</nz-modal>